import React, { forwardRef, memo } from "react";
import { Container } from "react-bootstrap";
import { m } from "framer-motion";
import { fadeIn } from "../../../../utils/GlobalAnimations";
import Utils from "../../../../utils/Utils";
import FancyTextBox from "../../fancyTextBox/FancyTextBox";

const FancyBoxPanel = forwardRef((props, ref) => {
  const { items, parent } = props;
  const cl = Utils.isValidJson(parent.className)
    ? JSON.parse(parent.className)
    : parent.className;

  return (
    <m.section
      ref={ref}
      className="bg-darkgray cover-background overflow-hidden"
      style={{ "--base-color": "#c3964e", ...cl }}
      {...fadeIn}
    >
      <Container fluid className="px-0">
        <FancyTextBox
          grid="row row-cols-1 row-cols-xl-4 row-cols-sm-2 gx-0 px-0"
          theme="fancy-text-box-05"
          data={items}
          animation={fadeIn}
        />
      </Container>
    </m.section>
  );
});

export default memo(FancyBoxPanel);
